document.addEventListener('DOMContentLoaded', function () {
  const closeModalButton = document.getElementById('closeModal');
  const modal = document.getElementById('modal');
  const form = document.getElementById('popupForm');
  const popup = document.querySelector('.popup');
  const defaultElements = document.querySelectorAll('.default');
  const submittedElements = document.querySelectorAll('.submitted');

  function hasQueryParam(param) {
    return new URLSearchParams(window.location.search).has(param);
  }

  if (hasQueryParam('customer_posted')) {
    localStorage.setItem('emailSubmitted', 'true');
  }

  if (localStorage.getItem('emailSubmitted')) {
    modal.style.display = 'none';
  } else {
    setTimeout(() => {
      modal.style.opacity = 1;
    }, 2300);
  }

  closeModalButton.addEventListener('click', function () {
    popup.style.opacity = 0;
    popup.style.transform = 'translateY(12px)';

    setTimeout(() => {
      modal.style.opacity = 0;
    }, 150);

    setTimeout(() => {
      modal.style.display = 'none';
    }, 450);
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    const formData = new FormData(form);
    fetch('/contact', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          localStorage.setItem('emailSubmitted', 'true');
          defaultElements.forEach((el) => (el.style.display = 'none'));
          submittedElements.forEach((el) => (el.style.display = 'block'));
          setTimeout(() => {
            modal.style.opacity = 0;
          }, 1150);
          setTimeout(() => {
            modal.style.display = 'none';
          }, 1450);
        } else {
          // Handle error here
        }
      })
      .catch((error) => {
        // Handle error here
      });
  });
});
